export const state = {
  lang: 'ja',
  loadingStack: [],
  timezone: '',
  toastStack: []
}
